// extracted by mini-css-extract-plugin
export default {"container":"OuterServicesRefinements_container__jY4pH","aside":"OuterServicesRefinements_aside__dQsM+","title":"OuterServicesRefinements_title__zfexY"};